import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import type { PalantirSize } from '../../shared/interfaces/sizes.interface';
import { PalantirSizeEnum } from '../../shared/interfaces/sizes.interface';
import type { PalantirTextType } from './text.type';
import { PalantirTextTypeEnum } from './text.type';

@Component({
  selector: 'palantir-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class PalantirTextComponent {
  @Input() public type: PalantirTextType = PalantirTextTypeEnum.text;

  @Input() public size: PalantirSize = PalantirSizeEnum.base;

  @Input() public truncate?: boolean | 'false' | 'true' = false;

  @Input() public italic?: boolean | 'false' | 'true' = false;

  public for = input<string>();
}
